import React from "react";
import { Link } from "react-router-dom";
import { getLinkCellStyle } from "../../utils/pluginHelpers.jsx";

export default function GridCallRecordsCardCell(props) {
    const value = props.dataItem[props.field];
    const href = `/card/callRecords/${value}`;
    return <td {...getLinkCellStyle(props)}>
        <Link to={href} title={window.captions.CardCallRecords}>
            <i className={`dm-i dm-i-chevron_right`} />
        </Link>
    </td>;
}